import { lazy } from 'solid-js'
import { messages } from '../../pages/newsroom-admin-page/newsroom-admin-page-routing.messages.en.js'

export default {
    component: lazy(() => import('../../pages/newsroom-admin-page/newsroom-admin-page.jsx')),
    descriptionMessage: messages.descriptionMessage,
    noIndex: true,
    path: '/admin/newsroom',
    showFooter: false,
    showHeader: true,
    titleMessage: messages.titleMessage,
}
